import { InputAdornment, InputBase, InputBaseProps, styled } from '@mui/material'
import { forwardRef } from 'react'

export interface IDefaultInputProps extends Omit<InputBaseProps, 'size'> {
  isDate: boolean
  onReset?: () => void
  hasError?: boolean
  inputSize?: 'small' | 'large'
}

interface IDefaultInputBaseProps extends InputBaseProps {
  isdate: number
  haserror?: number
  inputsize?: 'small' | 'large'
}

const DefaultInputBase = styled(InputBase)<IDefaultInputBaseProps>(({ theme, isdate, haserror, inputsize = 'small' }) => ({
  root: {
    height: inputsize === 'small' ? 32 : 40,
    padding: theme.spacing(1),
    '& > .MuiInputAdornment-positionStart': {
      color: haserror ? '#f44336' : '#464646'
    }
  },
  focused: {
    border: haserror ? '1px solid #f44336' : '1px solid #2570EB',
    '& > .MuiInputAdornment-positionStart': {
      color: haserror ? '#f44336' : theme.palette.primary.main
    }
  },
  input: {
    fontSize: 12,
    lineHeight: 2,
    color: isdate ? theme.palette.grey[700] : theme.palette.grey[600],
    padding: 0,
    width: '100%',
    minWidth: 160,

    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: theme.palette.grey[900]
    }
  },
  alignItems: 'center',
  borderRadius: theme.spacing(1),
  border: haserror ? '1px solid #f44336' : '1px solid #EFEFEF',
  height: inputsize === 'small' ? 32 : 40,
  padding: theme.spacing(0, 1.25, 0, 1.25),
  backgroundColor: 'white',
  '&:hover': {
    border: haserror ? '1px solid #f44336' : '1px solid #EFEFEF'
  }
}))

export const DefaultInput = forwardRef(({ onReset, hasError, isDate, inputSize = 'small', ...props }: IDefaultInputProps, ref) => {
  return (
    <DefaultInputBase
      haserror={hasError ? 1 : 0}
      isdate={isDate ? 1 : 0}
      inputsize={inputSize}
      startAdornment={
        <InputAdornment position="start">
          <i className={'fa-regular fa-calendar-range'} style={{ color: hasError ? '#f44336' : '#464646' }} />
        </InputAdornment>
      }
      endAdornment={
        isDate && (
          <InputAdornment position="end">
            {!props.value ? (
              <i className={'fa-regular fa-angle-down'} style={{ color: hasError ? '#f44336' : '#464646' }} />
            ) : (
              <i
                className={'fa-regular fa-xmark'}
                style={{ color: hasError ? '#f44336' : '#464646', cursor: 'pointer' }}
                onClick={e => {
                  e.stopPropagation()
                  onReset?.()
                }}
              />
            )}
          </InputAdornment>
        )
      }
      {...props}
      ref={ref}
    />
  )
})